<template>
	<div class="pl-2 mt-5 mb-3">
        <mw-dialog v-model="dialog" small @submit="submit" submit-btn cancel-btn :title="`Filter By '${column.text}'`">
            <template v-slot:button>
                <v-btn icon @click="dialog = true" :color="value.length ? 'primary' : 'secondary'"><v-icon>mdi-plus-circle</v-icon></v-btn>
            </template>
            <template v-slot:dialog-body>
                <v-checkbox multiple hide-details v-for="(answer, i) in answers" :key="i" v-model="selected" :value="answer" :label="String(answer) || '(blank)'" ></v-checkbox>
            </template>
        </mw-dialog>
	</div>
</template>


<script>
import MwDialog from "@c/ui/MwDialog";

export default {
    name: "FilterFooterCell", 
    props: {
        value: {type: Array, default: () => ([])}, 
        items: {type: Array}, 
        column: {type: Object},
    }, 
    computed: {
        answers(){
            const self = this;
            let answers = self.items.map( r => {
                return r[self.column.value]
            })
            answers = answers.filter( a => typeof a !== "undefined" );
            answers = answers.filter( (a, i, arr ) => arr.indexOf(a) == i );
            return answers;
        }
    }, 
    data: () => {
        return {
            dialog: false, 
            selected: []
        }
    }, 
    components: {
        MwDialog
    }, 
    methods: {
        submit(){
            this.$emit("input", this.selected )
        }
    }, 
    created(){
        this.selected = this.value;
    }
}
</script>